/**
 * Assisted Journey utility functions
 * Used for Share Consent Link feature - QR code, WhatsApp, SMS sharing
 */

export interface AssistedJourneyFlags {
  enabled: boolean;
  smsEnabled: boolean;
  whatsappEnabled: boolean;
}

/**
 * Reads assisted journey feature flags from sessionStorage.
 * These flags are set once during app initialization by auth-init-guard.service.ts
 * and remain constant for the session lifetime.
 */
export const getAssistedJourneyFlags = (): AssistedJourneyFlags => ({
  enabled: sessionStorage.getItem('assistedJourneyEnabled') === 'true',
  smsEnabled: sessionStorage.getItem('assistedJourneySmsEnabled') === 'true',
  whatsappEnabled: sessionStorage.getItem('assistedJourneyWhatsappEnabled') === 'true',
});

/**
 * Normalizes a phone number for WhatsApp API.
 * Adds Indian country code (91) if the number is 10 digits.
 * @param mobile - The mobile number string
 * @returns Normalized phone number with country code
 */
export const toWhatsAppNumber = (mobile: string): string => {
  const digits = mobile.replace(/\D/g, '');
  return digits.length === 10 ? `91${digits}` : digits;
};
